<div class="title">{{ titleText }}</div>
<div class="message">{{ messageText }}</div>
<div class="buttons-wrapper">
  <button *ngIf="isMobile" class="button" (click)="backClick()">
    {{ backTOShelfText }}
  </button>
</div>
